export class EntraRestoreReportSummaryByTypeValue {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requested",
            "baseName": "requested",
            "type": "number",
            "format": ""
        },
        {
            "name": "restored",
            "baseName": "restored",
            "type": "number",
            "format": ""
        },
        {
            "name": "skippedAlreadyExists",
            "baseName": "skippedAlreadyExists",
            "type": "number",
            "format": ""
        },
        {
            "name": "failed",
            "baseName": "failed",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReportSummaryByTypeValue.attributeTypeMap;
    }
    constructor() {
    }
}
